import readFileAsText from './readFileAsText';

// Returns `null` on invalid JSON — or an unreadable file — instead of
// throwing, so callers can show a friendly error.
const fileToJson = async (file) => {
  try {
    const text = await readFileAsText(file);
    return JSON.parse(text);
  } catch (e) {
    return null;
  }
};

export default fileToJson;
